import {Directive, HostListener} from '@angular/core';

@Directive({
    selector: '[appOnlyNumber]',
})
export class OnlyNumberDirective {
    private static isSpace(event: any) {
        return event.code === 'Space';
    }

    private static isNotANumberOrBackspace(event: any) {
        return isNaN(Number(event.key)) && event.code !== 'Backspace';
    }

    @HostListener('keydown', ['$event'])
    onInputChange(event: any): void {
        if ((OnlyNumberDirective.isNotANumberOrBackspace(event)) || OnlyNumberDirective.isSpace(event)) {
            event.preventDefault();
        }
    }
}